import { render } from "./Demo.vue?vue&type=template&id=65b1c5c6&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"

import "@/styles/pages/_demo.scss?vue&type=style&index=0&id=65b1c5c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65b1c5c6"

export default script